import { FormEvent, useState } from 'react';
import { useDispatch } from 'react-redux';

import ReactCodeInput from 'react-code-input';
import { RouteComponentProps } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import { P2, P3 } from '../../styles/FontStyles';
import {
  AuthLayoutTitle,
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { sendSecurityCode } from './SecurityCode.actions';
import { signInComplete } from '../../slices/auth-slice';

const SecurityCode = ({ history }: RouteComponentProps) => {
  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);

  const dispatch = useDispatch();
  const { signIn, loading } = useAppSelector((state) => state.auth);

  const searchParams = new URLSearchParams(location.search);

  const simplicity = searchParams.get('simplicity');

  const simplicityRedirectUri = searchParams.get('redirect_uri');

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    dispatch(
      signInComplete({
        signInToken: signIn?.signInToken || '',
        emailCode: code,
        twoFAcode: code2Fa,
        is2FARequired: signIn?.is2FARequired || false,
        history,
        simplicity,
        simplicityRedirectUri
      })
    );
  };

  const handleSendCode = () => {
    dispatch(
      sendSecurityCode({
        setIsCodeSent,
        signInToken: signIn?.signInToken || ''
      })
    );
  };

  return (
    <>
      {loading && <Spinner fullScreen={true} transparent />}
      <Flexed column>
        <AuthLayoutTitle>SECURITY VERIFICATION</AuthLayoutTitle>

        <form onSubmit={onHandleSubmit}>
          {signIn?.isEmailCodeVerificationRequired && (
            <>
              <Flexed between>
                <P2 bold color={colors.neutral700}>
                  Email verification code
                </P2>
                <P2
                  bold
                  style={{ cursor: 'pointer' }}
                  color={colors.primary900}
                  onClick={handleSendCode}>
                  Send Code
                </P2>
              </Flexed>
              <SecurityCodeWrapper>
                <ReactCodeInput
                  name='security-code'
                  fields={7}
                  value={code}
                  onChange={setCode}
                  type={'number'}
                  inputMode='numeric'
                />
              </SecurityCodeWrapper>
              <P3 color={colors.neutral500} mb='10'>
                {isCodeSent &&
                  `Enter the 7 digit code sent to ${signIn?.user?.email}`}
              </P3>
            </>
          )}

          {signIn?.is2FARequired && (
            <div>
              <Flexed between>
                <P2 bold color={colors.neutral700}>
                  2FA verification code
                </P2>
              </Flexed>
              <SecurityCodeWrapper is2Fa>
                <ReactCodeInput
                  fields={6}
                  value={code2Fa}
                  onChange={setCode2Fa}
                  type={'number'}
                  name='security-code'
                  inputMode='numeric'
                />
              </SecurityCodeWrapper>
              <P3 color={colors.neutral500} mb='10'>
                Enter the 6 digit code from your 2FA authenticator
              </P3>
            </div>
          )}
          <Button
            m='30px 0 10px 0'
            disabled={signIn?.is2FARequired ? code2Fa === '' : code === ''}>
            Confirm
          </Button>
        </form>
      </Flexed>
    </>
  );
};

export default SecurityCode;
